import React from 'react';

export const getInfoText = activeMethodData => {
  if (
    activeMethodData &&
    activeMethodData.authType === 'OTP' &&
    activeMethodData.otpChannel
  ) {
    try {
      if (
        activeMethodData.otpChannel.includes('SMS') &&
        activeMethodData.otpChannel.includes('EMAIL')
      ) {
        return (
          <>
            Enter the 6-digit OTP sent to your phone number{' '}
            <strong>{activeMethodData.phone}</strong> and email{' '}
            <strong>{activeMethodData.email}</strong>
          </>
        );
      }
      if (activeMethodData.otpChannel.includes('SMS')) {
        return (
          <>
            Enter the 6-digit OTP sent to your phone number{' '}
            <strong>{activeMethodData.phone}</strong>
          </>
        );
      }
      return (
        <>
          Enter the 6-digit OTP sent to your email{' '}
          <strong>{activeMethodData.email}</strong>
        </>
      );
    } catch (e) {
      return '';
    }
  } else if (activeMethodData && activeMethodData.authType === 'G2FA') {
    return (
      <>Enter the 6-digit authentication code from your authenticator app</>
    );
  }
  return '';
};
